import PropTypes from "prop-types";
import BasicInput from "../../reusable/input/BasicInput";
import MultiSelectInput from "../../reusable/input/MultiSelectInput";
import RadioInput from "../../reusable/input/RadioInput";
import Button from "../../reusable/Button";
import { object, string, number, array } from "yup";
import { useState } from "react";

function WorkInfo({ handleChange, error, updateError, next, loading }) {
  const [input, setInput] = useState({
    occupation: "",
    linkedin: "",
    hours_per_day: "",
    just_training: "",
    tasks: "",
  });

  let workInfoSchema = object({
    occupation: string().required("must select occupation"),
    linkedin: string()
      .required("must enter linkedin url")
      .url("must enter valid url"),
    hours_per_day: number().required(
      "must enter hours per day"
    ).typeError("Must input a number"),
    just_training: string().required("must say if you are just training"),
    tasks: array()
      .min(1, "must select at least one task")
      .typeError("You must select one or more tasks"),
  });

  const updateState = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
    handleChange(e);
  };

  async function submit(e) {
    e.preventDefault();
    workInfoSchema
      .validate(input)
      .then(() => {
        updateError({});
        next();
      })
      .catch((err) => {
        updateError({ name: err.path, message: err.message });
      });
  }

  return (
    <form autoComplete="on" onSubmit={submit}>
      <BasicInput
        name="occupation"
        label="Occupation"
        placeholder="Enter your occupation"
        type="text"
        onChange={updateState}
        error={error}
      />
      <BasicInput
        name="linkedin"
        label="LinkedIn Profile"
        placeholder="LinkedIn profile url"
        type="text"
        onChange={updateState}
        error={error}
      />
      <div className="lg:grid grid-cols-2 gap-x-8">
        <BasicInput
          name="hours_per_day"
          label="Hours/day"
          placeholder="Input Hours/day"
          type="number"
          onChange={updateState}
          error={error}
        />
        <RadioInput
          name="just_training"
          label="Want only Training"
          options={[true, false]}
          type="radio"
          onChange={updateState}
          error={error}
        />
      </div>
      <MultiSelectInput
        name="tasks"
        label="Tasks"
        placeholder="Select Tasks"
        options={[
          "Calendar Management",
          "Email Management",
          "Meeting Scheduling",
          "Administrative Duties",
          "Travel Arrangement",
          "Content Creation",
          "Social Media Management",
          "Creative Writing",
        ]}
        onChange={updateState}
        error={error}
      />
      <div className="flex justify-center my-8">
        <Button text="Sign up" loading={loading} />
      </div>
    </form>
  );
}

WorkInfo.propTypes = {
  handleChange: PropTypes.func,
  next: PropTypes.func,
  updateError: PropTypes.func,
  error: PropTypes.object,
  loading: PropTypes.bool,
};

export default WorkInfo;
